import { Route } from '@angular/router';
import { AuthGuardService } from '@surface-elements/shared/data-access-navigation';
import { HasRoleGuard } from '@surface-elements/shared/data-access';

export const omsFeatureShellRoutes: Route[] = [
  {
    path: 'login',
    loadChildren: () =>
      import('@surface-elements/login/feature-page').then(m => m.loginRoutes),
  },
  {
    path: 'accounts',
    loadChildren: () =>
      import('@surface-elements/accounts/feature-page').then(
        m => m.accountsRoutes,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: 'contacts',
    loadChildren: () =>
      import('@surface-elements/contacts/feature-page').then(
        m => m.contactsRoutes,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: 'jobs',
    loadChildren: () =>
      import('@surface-elements/jobs/feature-page').then(m => m.jobsRoutes),
    canActivate: [AuthGuardService],
  },
  {
    path: 'orders',
    loadChildren: () =>
      import('@surface-elements/orders/feature-page').then(m => m.ordersRoutes),
    canActivate: [AuthGuardService],
  },
  {
    path: 'reports',
    loadChildren: () =>
      import('@surface-elements/reports/feature-page').then(
        m => m.reportsRoutes,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('@surface-elements/settings/feature-page').then(
        m => m.settingsRoutes,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: 'dev-admin/users',
    loadComponent: () =>
      import('@surface-elements/admin/feature-users').then(
        m => m.UserListComponent,
      ),
    canActivate: [AuthGuardService, HasRoleGuard],
    data: { roles: ['SENDSERV_ADMIN'] },
  },
  {
    path: 'dev-admin/feature-flags',
    loadComponent: () =>
      import('@surface-elements/admin/feature-users').then(
        m => m.FlagAdminComponent,
      ),
    canActivate: [AuthGuardService, HasRoleGuard],
    data: { roles: ['SENDSERV_ADMIN'] },
  },
  { path: '', redirectTo: '/jobs', pathMatch: 'full' },
];
